var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('pazar-forushgahi-hero'),_c('pazar-forushgahi-details'),_c('page-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }